// extracted by mini-css-extract-plugin
export default {"melodyVideo":"oM-z","isFullWidth":"pM-z","landingPageVideo":"qM-z","play":"rM-z","iframeVideo":"sM-z","playHidden":"tM-z","fullwidth":"uM-z"};